<template>
  <section class="section">
    <h2 v-on:click="toggleItem" class="section-title">{{ sectionData.header }}
      <img class="expander-button" src="https://cdn.concertconsult.co.uk/1671-fund-factsheets/assets/icon-plus.svg"
        alt="Open" v-if="!toggled && !isPrintView">
      <img class="expander-button" src="https://cdn.concertconsult.co.uk/1671-fund-factsheets/assets/icon-minus.svg"
        alt="Close" v-if="toggled && !isPrintView">
    </h2>
    <div class="toggled-content" v-if="toggled || isPrintView" v-for="block in sectionData.blocks" :key="block.id">
      <BlockChart v-if="block.type === 'Chart'" :blockData="block.data" />
      <BlockTable v-if="block.type === 'Table'" :blockData="block.data" />
      <BlockText v-if="block.type === 'Text'" :blockData="block.data" />
      <BlockPerformance v-if="block.type === 'Performance'" :blockData="block.data" :fundName="factsheetData.name"
        :as-at-date="factsheetData.as_at_date" :hasBenchmark="factsheetData.has_benchmark"
        :fundData="factsheetData.fund_data" />
      <BlockRisk v-if="block.type === 'Risk'" :blockData="block.data" />
      <BlockSplitBar v-if="block.type === 'Split Bar'" :blockData="block.data" />
    </div>
  </section>
</template>

<script setup>

import { ref, onMounted } from 'vue';
import BlockTable from './BlockTable.vue';
import BlockChart from './BlockChart.vue';
import BlockSplitBar from './BlockSplitBar.vue';
import BlockText from './BlockText.vue';
import BlockRisk from './BlockRisk.vue';
import BlockPerformance from './BlockPerformance.vue';

const props = defineProps({
  sectionData: Object,
  factsheetData: Object,
  sectionIndex: Number,
  isPrintView: Boolean
})
var toggled = ref(true);


onMounted(() => {
  if (props.sectionIndex > 1) {
    toggled.value = false;
  }
})

const camelCase = function (str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
}
const whatBlockAmI = function (type) {
  let blockType = 'Block';
  blockType = blockType + type;
  return camelCase(blockType)
}

const toggleItem = function () {
  toggled.value = !toggled.value;
}
</script>

<style scoped>
$red: #de261c;

section.section {
  padding-bottom: 5px;
}

/deep/ .section-title {
  cursor: pointer;
  display: inline-block;

  &:hover {
    opacity: 0.8;
  }

  .expander-button {
    padding-left: 10px;
  }
}

@media print {
  .toggled-content {
    display: block !important;
  }

  .expander-button {
    display: none;
  }
}
</style>
